var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { GraphUtils } from './graph-utils';
export var Elections;
(function (Elections) {
    function createVoter(properties, state) {
        return properties.reduce(function (acc, property) {
            acc[property] = state[property] || false;
            return acc;
        }, {});
    }
    Elections.createVoter = createVoter;
    function getInitialVoterState(leafStateMap, properties) {
        var nodeIds = Object.keys(leafStateMap);
        return nodeIds.reduce(function (voters, nodeId) {
            voters[nodeId] = createVoter(properties, leafStateMap[nodeId]);
            return voters;
        }, {});
    }
    Elections.getInitialVoterState = getInitialVoterState;
    function getInitialElectionDepth(leafStateMap, graph) {
        var nodeIds = Object.keys(leafStateMap);
        var startDepth = 0;
        var depth = nodeIds.reduce(function (_depth, nodeId) {
            return Math.max(_depth, GraphUtils.getNode(graph, nodeId).depth);
        }, startDepth);
        return depth - 1;
    }
    Elections.getInitialElectionDepth = getInitialElectionDepth;
    // [voting] get all ancestor nodes at the next depth
    function getEligibleElections(graph, voterIds, depth) {
        var ancestorNodeIds = GraphUtils.getAllAncestorsFromList(graph, voterIds);
        return ancestorNodeIds.filter(function (nodeId) {
            return nodeId && GraphUtils.getNode(graph, nodeId).depth === depth;
        });
    }
    Elections.getEligibleElections = getEligibleElections;
    // capture if a vote was cast for or against a property
    function buildPropertyVotes(propSyncMap, voters) {
        var properties = Object.keys(propSyncMap);
        return properties.reduce(function (acc, property) {
            var votes = voters.reduce(function (_votes, voter) {
                var voterId = Object.keys(voter)[0];
                if (voter[voterId][property]) {
                    _votes.votesFor.push(voterId);
                }
                else {
                    _votes.votesAgainst.push(voterId);
                }
                return _votes;
            }, { votesFor: [], votesAgainst: [] });
            acc[property] = votes;
            return acc;
        }, {});
    }
    var trueWinsRules = function (tallies) {
        return { result: tallies.votesFor.length > 0, dissenters: __spread(tallies.votesAgainst) };
    };
    var falseWinsRules = function (tallies) {
        return { result: tallies.votesAgainst.length > 0, dissenters: __spread(tallies.votesFor) };
    };
    var majorityWinsRules = function (tallies) {
        var result = tallies.votesFor.length > tallies.votesAgainst.length;
        var dissenters = result ? __spread(tallies.votesAgainst) : __spread(tallies.votesFor);
        return { result: result, dissenters: dissenters };
    };
    var ruleFns = {
        'trueWins': trueWinsRules,
        'falseWins': falseWinsRules,
        'majorityWins': majorityWinsRules
    };
    function buildElectionResult(electionId, voteTallies, propSyncMap) {
        var properties = Object.keys(voteTallies);
        return properties.reduce(function (acc, property) {
            var tallies = voteTallies[property];
            var rule = propSyncMap[property] || 'majorityWins'; // safety net
            var _a = ruleFns[rule](tallies), result = _a.result, dissenters = _a.dissenters;
            acc[property] = {
                id: electionId,
                result: result,
                dissenters: dissenters,
                voters: __spread(tallies.votesFor, tallies.votesAgainst)
            };
            return acc;
        }, {});
    }
    Elections.buildElectionResult = buildElectionResult;
    function getElectionResults(graph, voters, elections, propSyncMap) {
        var remainingVoters = voters;
        var properties = Object.keys(propSyncMap);
        var results = elections.reduce(function (acc, electionId) {
            var successors = GraphUtils.getSuccessors(graph, electionId);
            var successorVoters = successors.map(function (id) {
                var _a;
                return _a = {},
                    _a[id] = voters[id] || createVoter(properties, GraphUtils.getState(graph, id, properties)),
                    _a;
            });
            successors.forEach(function (successorId) {
                delete remainingVoters[successorId];
            });
            var electionTallies = buildPropertyVotes(propSyncMap, successorVoters);
            var electionResults = buildElectionResult(electionId, electionTallies, propSyncMap);
            remainingVoters[electionId] = Object
                .entries(electionResults)
                .reduce(function (_acc, _a) {
                var _b = __read(_a, 2), property = _b[0], result = _b[1];
                _acc[property] = result.result;
                return _acc;
            }, {});
            acc.results.push(electionResults);
            return acc;
        }, { results: [] });
        return {
            results: results.results,
            remainingVoters: remainingVoters
        };
    }
    Elections.getElectionResults = getElectionResults;
})(Elections || (Elections = {}));
